import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
// import myTuluCover from "../../images/MyTulu/heroPdf.webp";
import myTuluCover from "../../images/MyTulu/headerDesktop.jpg";
import CoverHeader from "./CoverHeader";
import { TuluUnitExpended } from "./ExpendedMyTulu/TuluUnitExpended";
import { SuggestedProductsForRent } from "./ExpendedMyTulu/SuggestedProductsForRent";
import { TuluRideExpended } from "./ExpendedMyTulu/TuluRideExpended";

import { TuluUnitDrawExpended } from "./ExpendedMyTulu/TuluUnitDrawExpended";
import Expand from "react-expand-animated";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { RideRentPrintShop } from "./ride_rent_print_shop";
import { Costs } from "./costs";
import { Elevate } from "./elevate";
import { FooterMyTulu } from "./FooterMyTulu";
import { device } from "../device";
import { useMediaQuery } from "react-responsive";
import PlsRotate from "./PlsRotate";
import FaqExpend from "./ExpendedMyTulu/FaqExpend";
import PDF from "../../pages/PDF";
import { currencyByLocation } from "./currencyByLocation";
import { useNormalizeItems } from "./useNormalizeItems";
import addItemsCount from "./addSetItemsCount";
import Spinner from "../Spinner";

const MyTuluPage = ({ data }) => {
  const [PDFMode, setPDFMode] = useState(false);
  const [colorUnit, setColorUnit] = useState();
  const [buildingName, setBuildingName] = useState("");
  const [itemsCount, setItemsCount] = useState({});
  const [columns, setColumns] = useState();
  const [rideColumnItems, setRideColumnItems] = useState();
  const [rentItems, setRentItems] = useState();
  const [shopItems, setShopItems] = useState({});
  const [rideItems, setRideItems] = useState();
  const [logoImage, setLogoImage] = useState(null);
  const [hideIntroduction, setHideIntroduction] = useState(false);
  const [roomSimulationImage, setRoomSimulationImage] = useState(null);
  const [roomSimulationImageDesc, setRoomSimulationImageDesc] = useState(null);
  const [rideSimulationImage, setRideSimulationImage] = useState(null);
  const [rideSimulationImageDesc, setRideSimulationImageDesc] = useState(null);
  const [suggestedRentExpend, setSuggestedRentExpend] = useState(false);
  const [roomSimulationImageExpend, setRoomSimulationImageExpend] =
    useState(false);

  const [suggestedShopExpend, setSuggestedShopExpend] = useState(false);
  const [plansExpend, setPlansExpend] = useState(false);
  const [faqExpend, setFaqExpend] = useState(false);
  const [location, setLocation] = useState("us");
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [numOfUnit, setNumOfUnit] = useState("");
  const [setupFeeBeforeDiscount, setSetupFeeBeforeDiscount] = useState("");
  const [serviceFeeBeforeDiscount, setServiceFeeBeforeDiscount] = useState("");

  useEffect(() => {
    if (!data) return;

    setBuildingName(data.buildingName);
    setRoomSimulationImage(data.roomSimulationImage);
    setRoomSimulationImageDesc(data.roomSimulationImageDesc);
    setRideSimulationImage(data.rideSimulationImage);
    setRideSimulationImageDesc(data.rideSimulationImageDesc);
    setNumOfUnit(data.numOfUnit);
    setColorUnit(data.colorUnit);
    setSetupFeeBeforeDiscount(data.setupFeeBeforeDiscount);
    setServiceFeeBeforeDiscount(data.serviceFeeBeforeDiscount);
    setLocation(data.location);
    setLogoImage(data.logoImage);
    setHideIntroduction(data.hideIntroduction);
    currencySymbolByLocation(data.location);
    let newColumns = JSON.parse(data.columns);
    let ride = JSON.parse(data.rideItems);

    setColumns(newColumns);

    if (ride && ride.length > 0 && ride[0] && data.ride) {
      setRideColumnItems(ride);
    }

    if (newColumns) {
      addSetItemsCount({ ride, newColumns });
    }
    // Initialization keyed on `data`; addSetItemsCount/currencySymbolByLocation are
    // behavior-stable wrappers recreated each render, so adding them would re-run every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const currencySymbolByLocation = currencyByLocation(setCurrencySymbol);

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const is_iOS = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  useNormalizeItems(
    itemsCount,
    location,
    setShopItems,
    setRideItems,
    setRentItems
  );

  const addSetItemsCount = addItemsCount(setItemsCount);

  const _renderExpendTitle = (
    bool,
    setBool,
    title,
    expend,
    showUpperDivider,
    expanded = "general"
  ) => {
    return (
      <div>
        {showUpperDivider && (
          <div
            style={{
              borderBottom: "1px black solid",
              margin: isMobile ? "0 40px" : "0 100px",
            }}
          />
        )}
        <div>
          <ExpendTitleWrapper
            //className="eventsExpanded"
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "eventsExpanded",
                expanded: expanded,
              });
              setBool(!bool);
            }}
          >
            <div style={{ flex: 1 }}>{title}</div>
            <FontAwesomeIcon
              style={{ margin: "3px 10px" }}
              icon={bool ? faChevronUp : faChevronDown}
            />
          </ExpendTitleWrapper>
        </div>
        <Expand open={bool}>{expend}</Expand>
        <div
          style={{
            borderBottom: "1px black solid",
            margin: isMobile ? "0 40px" : "0 100px",
          }}
        />
      </div>
    );
  };

  if (!PDFMode)
    return (
      <Wrapper>
        <RotateOnMobileLandscape>
          <PlsRotate />
        </RotateOnMobileLandscape>

        {!hideIntroduction && (
          <>
            <CoverHeader
              img={myTuluCover}
              title={"Give Your Building\nthe Goods"}
              subtitle={
                "TULU provides on-demand access to the day-to-day things residents want and need, from home essentials to printers and scooters — and beyond."
              }
            />

            <RideRentPrintShop />
          </>
        )}

        {/*<PhysicalAndDigital />*/}

        {!columns && <Spinner />}

        {columns && (
          <ExpendedWrapper>
            <TuluUnitExpended
              colorUnit={colorUnit}
              logoImage={logoImage}
              columns={columns}
              itemsCount={itemsCount}
              buildingName={buildingName}
              headLine={"TULU UNIT"}
            />
            {rideColumnItems ? (
              <TuluRideExpended
                colorUnit={colorUnit}
                rideColumnItems={rideColumnItems}
                itemsCount={itemsCount}
              />
            ) : (
              <IphoneGap isIphone={is_iOS()} />
            )}
            <div>
              {roomSimulationImage &&
                _renderExpendTitle(
                  roomSimulationImageExpend,
                  setRoomSimulationImageExpend,
                  "TULU In Your Building",
                  <div style={{ paddingBottom: 15 }}>
                    <ImageWrapper>
                      {roomSimulationImageDesc && roomSimulationImageDesc}
                      <Img src={roomSimulationImage} />
                    </ImageWrapper>

                    {rideColumnItems && rideSimulationImage && (
                      <ImageWrapper>
                        {rideSimulationImageDesc && rideSimulationImageDesc}
                        <Img src={rideSimulationImage} />
                      </ImageWrapper>
                    )}
                  </div>,
                  true,
                  "Expanded TULU In Your Building"
                )}
            </div>

            <div>
              {_renderExpendTitle(
                suggestedRentExpend,
                setSuggestedRentExpend,
                "Suggested Products For Rent",
                <SuggestedProductsForRent
                  location={location}
                  items={{ ...rentItems, ...rideItems }}
                />,
                !roomSimulationImage,
                "Expanded Suggested Rent"
              )}
            </div>

            <div>
              {Object.keys(shopItems).length ? (
                <>
                  {_renderExpendTitle(
                    suggestedShopExpend,
                    setSuggestedShopExpend,
                    "Suggested Products For Purchase",
                    <SuggestedProductsForRent
                      location={location}
                      items={shopItems}
                    />,
                    false,
                    "Expanded Suggested Purchase"
                  )}
                </>
              ) : (
                ""
              )}
            </div>

            <div>
              {_renderExpendTitle(
                faqExpend,
                setFaqExpend,
                "Specs & Plans",
                <div>
                  <TuluUnitDrawExpended
                    colorUnit={colorUnit}
                    logoImage={null}
                    columns={columns}
                    itemsCount={itemsCount}
                    location={location}
                    rideItems={rideColumnItems}
                  />
                </div>,
                false,
                "Expanded Specs & Plans"
              )}
            </div>

            <div>
              {_renderExpendTitle(
                plansExpend,
                setPlansExpend,
                "FAQ",
                <FaqExpend />,
                false,
                "Expanded FAQ"
              )}
            </div>
          </ExpendedWrapper>
        )}

        {data?.setupFee && data.serviceFee && (
          <Costs
            ownerRevenue={data.ownerRevenue}
            currencySymbol={currencySymbol}
            numOfUnit={numOfUnit}
            setupFeeBeforeDiscount={setupFeeBeforeDiscount}
            setupFee={data.setupFee}
            serviceFeeBeforeDiscount={serviceFeeBeforeDiscount}
            serviceFee={data.serviceFee}
            buildingName={buildingName}
          />
        )}

        <Elevate buildingName={buildingName} setPDFMode={setPDFMode} />
        <FooterMyTulu />
      </Wrapper>
    );
  if (PDFMode) {
    return <PDF setPDFMode={setPDFMode} />;
  }
};

export { MyTuluPage };

const RotateOnMobileLandscape = styled.div`
  display: none;
  z-index: -99999;
  @media screen and (orientation: landscape) and (max-width: 900px) {
    display: block;
    position: fixed;
    z-index: 99999;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const ExpendedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #f2f4ea;
  @media ${device.mobileS} {
    padding-bottom: 40px;
  }
  @media ${device.tablet} {
    padding-bottom: 100px;
  }
`;

const IphoneGap = styled.div`
  @media ${device.mobileS} {
    margin-top: ${(props) => (props.isIphone ? 20 : 0)}px;
  }
  @media ${device.tablet} {
    margin-top: 0px;
  }
`;

const ExpendTitleWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: space-between;
  @media ${device.mobileS} {
    padding: 15px 40px;
    font-size: 15px;
  }
  @media ${device.tablet} {
    padding: 20px 100px;
    font-size: 20px;
  }
`;

const ImageWrapper = styled.div`
  font-family: DMSans, serif;
  margin: 0;
  @media ${device.mobileS} {
    width: 95%;
    padding: 10px 40px;
  }
  @media ${device.tablet} {
    //margin: 0 auto;
    font-size: 20px;
    padding: 10px 100px;
    width: 75%;
  }
`;

const Img = styled.img`
  width: 100%;
  object-fit: contain;
  display: flex;
  @media ${device.mobileS} {
    margin: 10px 0;
  }
  @media ${device.tablet} {
    width: auto;
    max-height: 700px;
  }
`;
